import React from "react";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./contact-form.styles.css";

const ContactForm = () => {
  return (
    <div>
      <h1 className="text-center font-details-b pb-3">CONTACT ME</h1>
      <Jumbotron className="contact-jumbotron">
        <Row>
          <Col className="d-flex justify-content-center flex-wrap">
            <div className="m-2">
              <a href="https://www.linkedin.com/in/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-primary" title="Visit my LinkenIn">
                  <i className="fab fa-linkedin"></i> LinkedIn
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="https://github.com/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-dark" title="My other projects">
                  <i className="fab fa-github-square"></i> GitHub
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="https://dev.to/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-dark" title="My tech blog">
                  <i className="fab fa-dev"></i> DevTo
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="mailto:abhinavnigam2207@gmail.com" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-danger" title="abhinavnigam2207@gmail.com">
                  <i className="fas fa-envelope-square"></i> Email Me
                </Button>
              </a>
            </div>
            <div className="m-2">
              <a href="https://www.facebook.com/abhinavnigam2207" target="_blank" rel="noopener noreferrer">
                <Button variant="outline-primary" title="Say hello on FB">
                  <i className="fab fa-facebook-square"></i> FaceBook
                </Button>
              </a>
            </div>

          </Col>
        </Row>
      </Jumbotron>
    </div>
  );
};

export default ContactForm;
